// @flow
import React from 'react';
import { Link } from 'react-router-dom';

import PageWrapper from '../../components/PageWrapper/PageWrapper';

/* eslint-disable react/jsx-curly-brace-presence */
const NoMatch = () => (
    <PageWrapper>
        <h3>Page Not Found</h3>
        <p>
            {`The page you are trying to navigate to doesn't exist.`}
        </p>
        <Link to="/">Return Home</Link>
    </PageWrapper>
);

export default NoMatch;
